import React from "react";
import { IonButton } from "@ionic/react";
import { answerVeto, useGameState } from "context/GameContext";
// Css
import classes from "./Veto.module.scss";
import { VetoState } from "context/interfaces/GameContextInterface";

const Veto: React.FC = () => {
  const { code } = useGameState();

  return (
    <div className={classes.container}>
      <h2 className={classes.title}>Veto</h2>
      <p className={classes.description}>
        As president are you agree with veto?
      </p>
      <div>
        <IonButton
          size="small"
          onClick={() => answerVeto(code, VetoState.Agree)}
        >
          yes
        </IonButton>
        <IonButton
          size="small"
          onClick={() => answerVeto(code, VetoState.Decline)}
        >
          no
        </IonButton>
      </div>
    </div>
  );
};

export default Veto;
